import { LocalDate } from 'js-joda';

import AppConstants from 'constants/AppConstants';

interface LocalDateRange {
  endDate: LocalDate;
  startDate: LocalDate;
}

export interface PayoutsReportActions {
  fetchReport(dateRange: LocalDateRange): void;
  setDateRange(dateRange: Partial<LocalDateRange>): void;
}

export function fetchReport(dateRange: LocalDateRange): ApiAction {
  return {
    TockApi: {
      getListProto: `/reports/payouts?start_date=${dateRange.startDate}&end_date=${dateRange.endDate}`,
      type: AppConstants.FETCH_PAYOUTS_FOR_REPORT,
    },
  };
}

export function setDateRange(dateRange: Partial<LocalDateRange>): BaseTockAction {
  return {
    payload: dateRange,
    type: AppConstants.SET_PAYOUTS_REPORT_DATE_RANGE,
  };
}
